import { forwardRef } from 'react';
import cx from 'classnames';
import { useIsRTL } from '../../../locale';
import { renderInlineCssVars, useDesignTokens } from '../../../theme';
import { postfixTestId } from '../../../util/testId';
import { InvisibleText } from '../../InvisibleText';
import cn from './SliderRange.css.json';
import './SliderRange.css';
import { useFeatureFlag } from '../../../hooks/useFeatureFlag';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SliderRange = /*#__PURE__*/forwardRef(function SliderRange({
  xStyle,
  className,
  style: userStyle,
  ...props
}, ref) {
  const style = {};
  const isRTL = useIsRTL();
  const length = `${(xStyle.maxPos - xStyle.minPos) * 100}%`;
  if (xStyle.orientation === 'vertical') {
    style.top = `${(1 - xStyle.maxPos) * 100}%`;
    style.height = length;
  } else {
    style.left = `${(isRTL ? 1 - xStyle.maxPos : xStyle.minPos) * 100}%`;
    style.width = length;
  }
  const {
    testId,
    ariaLabel,
    showExclusive,
    ...rest
  } = props;
  const invisibleTextId = props['aria-labelledby'];
  const dt = useDesignTokens();
  // Feature flag for 'New Token Values'
  const isNewTokenValueFlagEnabled = useFeatureFlag('NOVACOMMONS-22288_ThemeModernization_NewTokenValues');
  const tokens = renderInlineCssVars(getSliderRangeToken(dt, showExclusive || false, isNewTokenValueFlagEnabled), 'slider-range');
  return /*#__PURE__*/_jsxs("div", {
    "data-testid": postfixTestId(props.testId, 'container'),
    className: cn.container[xStyle.orientation],
    children: [ariaLabel ? /*#__PURE__*/_jsx(InvisibleText, {
      id: invisibleTextId,
      testId: postfixTestId(props.testId, 'invisibleText'),
      children: ariaLabel
    }) : undefined, /*#__PURE__*/_jsx("div", {
      ...rest,
      "data-testid": props.testId,
      ref: ref,
      className: cx(className, props.disabled && cn.disabled, cn[xStyle.orientation], xStyle.enableFocusOutline && cn.rangeEnableFocusOutline, showExclusive && cn.showExclusive),
      style: {
        ...tokens,
        ...style,
        ...userStyle
      },
      children: props.children
    })]
  });
});
const getSliderRangeToken = (dt, showExclusive, isNewTokenValueFlagEnabled) => {
  if (dt.enableNovaTokens) {
    return {
      bg: showExclusive ? dt.tokens['color-container-background-0'] : dt.tokens['color-action-background-on-off-selected'],
      'disabled-bg': showExclusive ? dt.tokens['color-action-background-on-off-read-only'] : dt.tokens['color-action-background-on-off-selected-disabled'],
      'outline-offset': '1px',
      ...(!isNewTokenValueFlagEnabled && {
        'outline-offset': 'calc(-1 * var(--focus-width) -2px)'
      })
    };
  } else {
    return {
      bg: showExclusive ? dt.reportTokens.backgrounds.page.bg : dt.reportTokens.stateSecondaryToggle.selected.bg,
      'disabled-bg': showExclusive ? dt.reportTokens.stateSecondaryToggle.selected.bg : dt.reportTokens.stateSecondaryToggle.disabledSelected.bg
    };
  }
};
//# sourceMappingURL=SliderRange.js.map